import React from 'react';
import { Col, Row } from 'react-bootstrap';
import './DatosGeneralesFactura.scss';

const DatosGeneralesFactura = ({ datosFactura = {} }) => {

  const retornarComponenteMediosPagos = () => {
    if(datosFactura.medio_pago === 'Banco'){
      return <MetodoBanco detalle={datosFactura.detalle} />
    }
    if(datosFactura.medio_pago === 'Cheque') {
      return <MetodoCheque detalle={datosFactura.detalle}/>
    }
    if(datosFactura.medio_pago === 'Tarjeta') {
      return <MetodoTarjeta detalle={datosFactura.detalle}/>
    }
    if(datosFactura.medio_pago === 'Billetera movil') {
      return <MetodoBilleteraMovil detalle={datosFactura.detalle}/>
    }
  }

  console.log({datosFactura});

  return ( 
    <div className="DatosGeneralesFactura">
      <h4 className="title-head">Datos Generales</h4>
        <div className="box datos-recibo">
          <div className="box-body">
            <Row>
              <Col md={4}>
                <p>Nombre y apellidos: <span>{datosFactura.nombre_discente}</span></p>
              </Col>
              <Col md={8}>
                <p>Evento: <span>{datosFactura.nombre_proyecto}</span></p>
              </Col>
            </Row>
            <Row className='mt-3'>
              <Col md={4}>
                <p>Concepto: <span>{datosFactura.concepto}</span></p>
              </Col>
              <Col md={4}>
                <p>Área: <span>{datosFactura.tp_area}</span></p>
              </Col>
              <Col md={4}>
                <p>Fecha: <span>{datosFactura.fecha}</span></p>
              </Col>
            </Row>
            <Row className='mt-3'>
              <Col md={4}>
                <p>Medio de pago: <span>{datosFactura.medio_pago}</span></p>
              </Col>
              {
                datosFactura.detalle && retornarComponenteMediosPagos() 
              }
            </Row>
            <Row className='mt-3'>
              <Col md={12}>
                <p>Observaciones: <span>{datosFactura.observaciones}</span></p>
              </Col>
            </Row>
          </div>
        </div>
    </div>
  );
}
 
export default DatosGeneralesFactura;

const MetodoCheque = ({ detalle = {} }) => {
  return (
    <>
      <Col md={4}>
        <p>Nombre Banco: <span>{detalle.nombre_banco}</span></p>
      </Col>
      <Col md={4}>
        <p>N° Operación del banco: <span>{detalle.nro_cheque}</span></p>
      </Col>
      {detalle.nro_operacion_cliente && (
      <Col md={4}>
        <p>N° Operación del Cliente: <span>{detalle.nro_operacion_cliente}</span></p>
      </Col>
      )}

    </>
  )
}

const MetodoBanco = ({ detalle = {} }) => {
  return (
    <>
      <Col md={4}>
        <p>Nombre Banco: <span>{detalle.nombre_banco}</span></p>
      </Col>
      {detalle.nro_operacion_cliente && (
      <Col md={4}>
        <p>N° Operación del Cliente : <span>{detalle.nro_operacion_cliente}</span></p>
      </Col>
      )}
      <Col md={4}>
        <p>N° Operación del banco : <span>{detalle.nro_operacion}</span></p>
      </Col>
    </>
  )
}


const MetodoTarjeta = ({ detalle = {} }) => {
  return (
    <>
    {detalle.nro_operacion_cliente && (
      <Col md={4}>
        <p>N° Operación del Cliente: <span>{detalle.nro_operacion_cliente}</span></p>
      </Col>
    )}
    {detalle.nro_operacion && (
      <Col md={4}>
        <p>N° Operación del banco: <span>{detalle.nro_operacion}</span></p>
      </Col>
    )}
    {detalle.codigo_referencia && (
      <Col md={4}>
        <p>Cod. de referencia: <span>{detalle.codigo_referencia}</span></p>
      </Col>
    )}
    </>
  )
  
}

const MetodoBilleteraMovil = ({ detalle = {} }) => {
  return (
    <>
    {detalle.nro_operacion_cliente && (
    <Col md={4}>
        <p>N° Operación de Cliente: <span>{detalle.nro_operacion_cliente}</span></p>
      </Col>
    )}
    {detalle.nro_operacion_billetera && (
    <Col md={4}>
        <p>N° Operación del Banco: <span>{detalle.nro_operacion_billetera}</span></p>
      </Col>
    )}
    </>
  )
}